import { useAnim, useSEO } from "../hooks.jsx";
import { Link } from "react-router-dom";
import { Ic } from "../icons.jsx";
import { FEATURES, PAGE_SEO, SCHEMA_HOME } from "../data.js";
import MockBrowser from "../components/MockBrowser.jsx";
import CtaBand from "../components/CtaBand.jsx";
import GuideLinks from "../components/GuideLinks.jsx";

export default function Home({ go }) {
  useAnim();
  useSEO({ ...PAGE_SEO.home, schema: SCHEMA_HOME });

  return (
    <>
      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero-grid" />
        <div className="hero-in">
          <div>
            <div className="hero-kicker">
              <span className="hero-kicker-dot" />
              Prova gratuita — 14 giorni
            </div>
            <h1 className="h1">
              Crea il tuo sito e gestisci<br />il <mark>noleggio auto e moto</mark>
            </h1>
            <p className="hero-p">
              La piattaforma gestionale che <strong>ti aiuta a generare il tuo sito web</strong>, per far <strong>prenotare e pagare i clienti tutto online</strong>. Include gestione prenotazioni, contratti PDF e pagamenti, tutto in un posto solo.
            </p>
            <div className="hero-rating">
              {/* Audit 2026-09-20, punto #19: rimossi 4.9/5 + 3 iniziali fittizie
                  (M/G/S) — erano segnaposto senza clienti reali dietro, e la
                  Direttiva Omnibus (2161/2019, recepita nel Codice del Consumo)
                  classifica come pratica ingannevole per sé la finzione di
                  recensioni/valutazioni non verificate. Sostituite con
                  affermazioni vere e verificabili. */}
              <div className="hr-stars">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </div>
              <span className="hr-txt">Costruito su Stripe, Firebase e Google Maps · Conforme GDPR</span>
            </div>
            <div className="hero-btns">
              <Link to="/register" className="btn btn-p btn-lg" style={{ textDecoration:"none" }}>
                Inizia gratis — 14 giorni <Ic n="arrow" s={18} />
              </Link>
              <Link to="/contatti" className="btn btn-o btn-lg" style={{ textDecoration:"none" }}>
                Contattaci
              </Link>
              <Link to="/come-funziona" className="btn btn-o btn-lg" style={{ textDecoration:"none" }}>
                Come funziona
              </Link>
            </div>
            <div className="hero-proof">
              {["Nessuna carta richiesta","Setup in 5 minuti","Cancelli quando vuoi"].map(t => (
                <div className="proof-i" key={t}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                  {t}
                </div>
              ))}
            </div>
            {/* Trustpilot: solo logo + link (nessun punteggio/stelle mostrati,
                per non esporre valutazioni non verificate — vedi nota Omnibus sopra). */}
            <div className="hero-tp">
              <a
                className="hero-tp-logo"
                href="https://www.trustpilot.com/review/noleggioincloud.app"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Vedi le recensioni di NoleggioInCloud su Trustpilot"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="#00b67a" d="M12 1.5l3.1 7.2 7.9.7-6 5.2 1.8 7.7L12 18.1 5.2 22.3 7 14.6 1 9.4l7.9-.7z" />
                </svg>
                <span className="hero-tp-name">Trustpilot</span>
              </a>
              <div className="hero-tp-links">
                <a href="https://www.trustpilot.com/review/noleggioincloud.app" target="_blank" rel="noopener noreferrer">
                  Leggi le recensioni
                </a>
                <a href="https://www.trustpilot.com/evaluate/noleggioincloud.app" target="_blank" rel="noopener noreferrer">
                  Lascia una recensione
                </a>
              </div>
            </div>
          </div>
          <div style={{ position:"relative" }}>
            <MockBrowser type="auto" />
            <div className="hero-badge">
              <div className="hero-badge-ic">
                <Ic n="cal" s={18} />
              </div>
              <div>
                <div className="hero-badge-t">Nuova prenotazione</div>
                <div className="hero-badge-s">Marco R. — 2 min fa</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── STATS BAR ── */}
      <div className="sbar">
        <div className="sbar-in">
          {[
            { n:"14 giorni", l:"Prova gratuita" },
            { n:"5 min",     l:"Setup iniziale" },
            { n:"Auto+Moto", l:"Gestione unificata" },
            { n:"€0",        l:"Per iniziare" },
          ].map(s => (
            <div className="si" key={s.l}>
              <div className="si-n j">{s.n}</div>
              <div className="si-l">{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── FEATURE PREVIEW ── */}
      <section className="sec" style={{ background:"var(--bg)" }}>
        <div className="wrap">
          <div className="tc an">
            <div className="chip">Funzionalità</div>
            <h2 className="h2">Tutto quello che serve<br />al tuo noleggio</h2>
            <p className="lead c">Una piattaforma completa: dalla flotta al contratto, tutto incluso.</p>
          </div>
          <div className="fg">
            {FEATURES.slice(0, 6).map((f, i) => (
              <article className={`fc an d${(i % 3) + 1}`} key={f.t}>
                <div className={`fi ${f.c}`}><Ic n={f.i} s={21} /></div>
                <h3 className="ft">{f.t}</h3>
                <p className="fd">{f.d}</p>
              </article>
            ))}
          </div>
          <div style={{ textAlign:"center", marginTop:"2.25rem" }}>
            <Link to="/funzionalita" className="btn btn-o" style={{ textDecoration:"none" }}>
              Tutte le funzionalità <Ic n="arrow" s={16} />
            </Link>
          </div>
        </div>
      </section>

      {/* ── PERCHÉ FIDARTI ──
          Audit 2026-09-20, punto #19: sezione TESTIMONIALS rimossa — erano
          3 testimonianze firmate con nome/città (compresa una rivendicazione
          numerica "+35% prenotazioni" non verificabile) senza clienti reali
          dietro. La Direttiva Omnibus (2161/2019, recepita nel Codice del
          Consumo) vieta di presentare recensioni come genuine senza esserlo;
          le sanzioni AGCM partono da 5.000€. Sostituita con prova sociale
          onesta: affermazioni vere, verificabili, e più persuasive per un
          noleggiatore che teme i controlli di un testimonial anonimo. */}
      <section className="sec">
        <div className="wrap">
          <div className="tc an">
            <div className="chip g">Perché fidarti</div>
            <h2 className="h2">Costruito sulle basi giuste</h2>
          </div>
          <div className="fg">
            {[
              { icon: "credit", title: "Pagamenti Stripe", desc: "Integrazione nativa e conforme PCI DSS. Le carte dei tuoi clienti non passano mai dai nostri server." },
              { icon: "lock",   title: "Conforme GDPR",    desc: "DPA (Data Processing Agreement) incluso per ogni azienda cliente. Dati ospitati su infrastruttura Google Firebase in UE." },
              { icon: "shield", title: "Integrazione CaRGOS", desc: "Comunicazione automatica alla Questura per i noleggi soggetti all'obbligo di legge (art. 17 D.L. 113/2018)." },
            ].map((f, i) => (
              <article className={`fc an d${i + 1}`} key={f.title}>
                <div className="fi"><Ic n={f.icon} s={21} /></div>
                <h3 className="ft">{f.title}</h3>
                <p className="fd">{f.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <GuideLinks />

      <CtaBand go={go} />
    </>
  );
}
